import React from 'react';
import { useTranslation } from 'react-i18next';
import { SettlementStatus } from '../../../../../models/payroll';

interface Props {
  status: SettlementStatus;
  confirmedOn?: string;
}

export const SettlementLockedBanner: React.FC<Props> = ({ status, confirmedOn }) => {
  const { t } = useTranslation('common');

  return (
    <div className="flex items-start gap-3 rounded-xl border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-800 dark:border-green-800 dark:bg-green-950 dark:text-green-300">
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <span className="mt-0.5 text-green-500" aria-hidden="true">✓</span>
      <div className="flex-1">
        <p className="font-semibold">
          {status === 'Paid' ? t('Settlement Paid') : t('Settlement Confirmed')}
        </p>
        {confirmedOn && (
          <p className="mt-0.5 text-green-700 dark:text-green-400">
            {t('Confirmed on')} {new Date(confirmedOn).toLocaleDateString('en-GB')}
          </p>
        )}
        <p className="mt-1 text-xs text-green-600 dark:text-green-500">
          {t('This settlement is locked and cannot be modified.')}
        </p>
      </div>
    </div>
  );
};
